import React from 'react'
import {Link} from 'gatsby'

import {
  EuiCard,
  EuiButton,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer
} from '@elastic/eui'

import camera9008 from "../../../images/Frequently_Asked_Question/Angle_of_View/IN-9008FHD_Lense-Adjustment.png"
import camera5907 from "../../../images/Frequently_Asked_Question/Angle_of_View/IN-5907HD_Lense-Adjustment.png"
import camera5905 from "../../../images/Frequently_Asked_Question/Angle_of_View/IN-5905HD_Lense-Adjustment.png"




export default function WebUIArticles() {

  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Outdoor_Cameras/IN-9008_HD/Usermanual/">
                  <img
                    src={camera9008}
                    alt="IN-9008 Full HD Handbuch"
                  />
                </Link>
              }
              title='IN-9008 Full HD Handbuch'
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Outdoor_Cameras/IN-9008_HD/Usermanual/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Outdoor_Cameras/IN-5907_HD/Usermanual/">
                  <img
                    src={camera5907}
                    alt="IN-5907 HD Handbuch"
                  />
                </Link>
              }
              title='IN-5907 HD Handbuch'
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Outdoor_Cameras/IN-5907_HD/Usermanual/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Outdoor_Cameras/IN-5905_HD/Usermanual/">
                  <img
                    src={camera5905}
                    alt="IN-5905 HD Handbuch"
                  />
                 </Link>
              }
              title='IN-5905 HD Handbuch'
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Outdoor_Cameras/IN-5905_HD/Usermanual/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
